// @ts-nocheck
import { Log, UserManager } from 'oidc-client-ts';

import getServiceLocation from '@/lib/getServiceLocation';

import { configureStorage } from './storage';

export const handleLoginRedirect = async () => {
    const runsInIframe = window?.parent && window.parent !== window;
    const storage = configureStorage(window);

    if (runsInIframe) {
        // Silent redirect within an <iframe>
        Log.setLogger(console);
        Log.setLevel(Log.INFO);

        await new UserManager({
            authority: getServiceLocation('authority'),
            client_id: import.meta.env.VITE_AUTH_CLIENT_ID,
            redirect_uri: getServiceLocation('redirect'),
        }).signinSilentCallback();
    } else {
        await new UserManager({
            authority: getServiceLocation('authority'),
            client_id: import.meta.env.VITE_AUTH_CLIENT_ID,
            redirect_uri: getServiceLocation('redirect'),
        }).signinRedirectCallback(window.location.href);

        const initialRoute = storage.getRoute();
        storage.discardRoute();
        window.location.replace(`${window.location.origin}${initialRoute || '#/?'}`);
    }
};
